export default __webpack_public_path__ + "static/media/Mask Group 143.39be8509.svg";